import React, { useContext, useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import Tabs from '@material-ui/core/Tabs'
import Tab from '@material-ui/core/Tab'
import Typography from '@material-ui/core/Typography'
import Box from '@material-ui/core/Box'
import Container from '@material-ui/core/Container'

import DashboardHeader from '../DashboardHeader'
import FavouriteAuctions from '../../../Component/FavouriteList/FavouriteAuctions'
import Layout from '../Layout'
import { AppBar, useMediaQuery } from '@material-ui/core'
import LotProduct from '../../../Component/ProductCard/lotProduct'
import Slider from 'react-slick'
import ProductContext from '../../../Product/context/product/productContext'
import { useFormik } from 'formik'
import AuthContext from '../../../Product/context/auth/authContext'
import { addSlashes } from '../../../utils/commonFunctions'
import Popup from '../../../Product/components/organisms/Popup'
import SEOTAG from '../../../utils/CommonFunctionality/SEO/AllpagesSEO'

const TabPanel = ({ children, value, index, ...other }) => {
    return (
        <Typography
            component="div"
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box p={3}>{children}</Box>}
        </Typography>
    )
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
}

function a11yProps(index) {
    return {
        id: `buyer-dashboard-${index}`,
        'aria-controls': `buyer-dashboard-tabpanel-${index}`,
    }
}

const Favourites = (props) => {
    const productContext = useContext(ProductContext)
    const authContext = useContext(AuthContext)
    const [value, setValue] = useState('one')
    const [viewProduct, setViewProduct] = useState([])
    const [openQrModal, setOpenQrModal] = useState(false)
    const params = new URLSearchParams(location.search)
    const handleChange = (event, newValue) => {
        setValue(newValue)
    }
    const { user, isAuthenticated } = authContext
    const { search_allproducts, getAllSearchProducts, productLocalState, getAllSearchItems } =
        productContext
    const [suggestedProducts, setSuggestedProducts] = useState([])
    const [recentlyViewedProducts, setRecentlyViewedProducts] = useState([])
    const isVarifiedGfTheme = global.storeConfigration?.bodyClass?.value === 'greenField'
    const isMobile = useMediaQuery('(max-width:600px)')
    const isBargainsProject = global.storeConfigration?.bodyClass2?.value === 'bargainsClass'
    const [suggestedItemSearch, SetSuggestedItemSearch] = useState({
        orderby: '',
        category: [],
        subcategory: [],
        closed_auction_list: 0,
        perlimit: isVarifiedGfTheme ? 4 : 10,
        no_pagination: isVarifiedGfTheme ? 1 : 0,
        page: 1,
        joinsdata: `a.title as auctionTitle, p.title,a.state as auction_state, a.city as auction_city,a.address as auction_address, a.zipcode as auction_zipcode, p.lot_number,p.sku,p.deed_document,p.lotof,p.auctionnotes,p.avatar as avatar_vc,p.content_head1,p.store_id,p.retailer_link,p.conditionunique,p.hasshipping,p.user_id,p.category_id${
            user?.id ? ',IFNULL(w.id,0) as watchlisted' : ''
        }`,
        nobids: isVarifiedGfTheme ? 1 : 1,
        latestbid: isVarifiedGfTheme ? 0 : 1,
        latestbid_user: 1,
        userid: user?.id,
        getbidding: isVarifiedGfTheme ? 0 : 1,
        need_bid_increment: isVarifiedGfTheme ? 0 : 1,

        order_by: ' order by p.most_viewed DESC',
        customwhere: 'p.market_status="open" and p.qty > 0 ',
        joins: user?.id
            ? `left join watchlists as w on w.project_id=p.id and w.user_id = ${user?.id} and w.is_delete = 0 inner join auctionlot as a on a.id=p.lotof `
            : ` inner join auctionlot as a on a.id=p.lotof `,

        location: [],
        from: 'auction_only',
        from_id: 1,
        auction_io: 1,
        auction_city:
            productLocalState.globalLocation != 'All' ? [productLocalState.globalLocation] : [],
        size: [],
        get_city_state: 1,
        dont_show: global?.storeConfigration?.donot_show_categories?.value
            ? global.storeConfigration?.donot_show_categories?.value?.split(',')
            : [],
    })

    const [recentlyViewedSearch, SetRecentlyViewedSearch] = useState({
        closed_auction_list: 0,
        perlimit: isVarifiedGfTheme ? 10 : 50,
        no_pagination: isVarifiedGfTheme ? 1 : 0,
        from: 'auction_only',
        from_id: 1,
        auction_io: 1,
        auction_city:
            productLocalState.globalLocation != 'All' ? [productLocalState.globalLocation] : [],
        joinsdata: isVarifiedGfTheme
            ? 'p.avatar as avatar_vc'
            : 'a.title as auctionTitle, p.title,a.state as auction_state, a.city as auction_city,a.address as auction_address, a.zipcode as auction_zipcode,p.lot_number,p.sku,p.deed_document,p.lotof,p.auctionnotes,p.avatar as avatar_vc,p.content_head1,p.store_id,p.retailer_link,p.conditionunique,p.hasshipping,p.user_id,p.category_id',
        size: [],
        get_city_state: 1,
        joins: ' inner join auctionlot as a on a.id=p.lotof ',
    })

    const getOrderBy = (orderby) => {
        let order = ' order by '

        if (orderby == '') {
            order += 'p.date_closed asc'
        }
        if (orderby == 3) {
            order += 'IF (p.auction = 1, p.wprice,p.bprice) asc'
        }
        if (orderby == 11) {
            order += 'IF (p.auction = 1, p.wprice,p.bprice) desc'
        }
        if (orderby == 6) {
            order += 'p.date_closed asc'
        }
        if (orderby == 2) {
            order += 'p.id desc'
        }
        if (orderby == 14) {
            if (global?.storeConfigration?.lot_sequence_order?.value == 1)
                order += 'CAST(p.lot_number AS UNSIGNED) ASC'
            else order += 'CAST(p.sku AS UNSIGNED) ASC'
        }
        if (orderby == 15) {
            if (global?.storeConfigration?.lot_sequence_order?.value == 1)
                order += 'CAST(p.lot_number AS UNSIGNED) DESC'
            else order += 'CAST(p.sku AS UNSIGNED) DESC'
        }
        if (
            global?.storeConfigration?.lot_sequence_order?.value == 1 &&
            orderby != 14 &&
            orderby != 15
        ) {
            order += ',CAST(p.lot_number AS UNSIGNED) ASC '
        }

        return order
    }
    const getSearchBar = (searchbar) => {
        let where = ''
        if (searchbar) {
            const searchValue = searchbar.trim()
            if (
                global.storeConfigration?.show_warehouse_location?.value == 1 &&
                global.storeConfigration?.lot_sequence_order?.value == 1
            ) {
                where +=
                    ' and (p.title like "%' +
                    addSlashes(searchValue) +
                    '%" or p.tags like "%' +
                    addSlashes(searchValue) +
                    '%" or p.description like "%' +
                    addSlashes(searchValue) +
                    '%" or p.location like "%' +
                    addSlashes(searchValue) +
                    '%" or p.lot_number like "%' +
                    addSlashes(searchValue) +
                    '")'
            } else if (global.storeConfigration?.lot_sequence_order?.value == 1) {
                where +=
                    ' and (p.title like "%' +
                    addSlashes(searchValue) +
                    '%" or p.tags like "%' +
                    addSlashes(searchValue) +
                    '%" or p.lot_number like "%' +
                    addSlashes(searchValue) +
                    '")'
            } else if (global.storeConfigration?.show_warehouse_location?.value == 1) {
                where +=
                    ' and (p.title like "%' +
                    addSlashes(searchValue) +
                    '%" or p.tags like "%' +
                    addSlashes(searchValue) +
                    '%" or p.description like "%' +
                    addSlashes(searchValue) +
                    '%" or p.location like "%' +
                    addSlashes(searchValue) +
                    '")'
            } else {
                where +=
                    ' and (p.title like "%' +
                    addSlashes(searchValue) +
                    '%" or p.tags like "%' +
                    addSlashes(searchValue) +
                    '%" or p.description like "%' +
                    addSlashes(searchValue) +
                    '%" or p.lot_number like "%' +
                    addSlashes(searchValue) +
                    '")'
            }
        }
        return where
    }
    const getWhere = (type, keys) => {
        let where = 'p.auction=1 and p.buynow=0 and p.market_status="open"'
        if (type === 'search') {
            where += getSearchBar(keys)
        }
        if (type === 'location') {
            where += keys
        }
        return where
    }
    const formik = useFormik({
        initialValues: {
            orderby: '',
            category: [],
            subcategory: [],
            closed_auction_list: 0,
            perlimit: 50,
            page: 1,
            joinsdata: `a.state as auction_state, a.city as auction_city,a.address as auction_address, a.zipcode as auction_zipcode,p.lot_number,p.sku,p.deed_document,p.lotof,p.auctionnotes,p.avatar as avatar_vc,p.content_head1,p.store_id,p.retailer_link,p.conditionunique,p.hasshipping,p.user_id,p.category_id${
                user?.id ? ',IFNULL(w.id,0) as watchlisted' : ''
            }`,
            nobids: 1,
            latestbid: 1,
            latestbid_user: 1,
            userid: user?.id,
            getbidding: 1,
            need_bid_increment: 1,

            order_by: getOrderBy(''),
            customwhere: params.get('q')
                ? getWhere('search', params.get('q'))
                : getWhere('search', ''),
            joins: user?.id
                ? `left join watchlists as w on w.project_id=p.id and w.user_id = ${user?.id} and w.is_delete = 0 inner join auctionlot as a on a.id=p.lotof `
                : ` inner join auctionlot as a on a.id=p.lotof `,

            location: [],

            toprice: 0,
            quality_rating: [],
            from: 'auction_only',
            from_id: 1,
            auction_io: 1,

            auction_city: [],
            size: [],
            get_city_state: 1,
            dont_show: global?.storeConfigration?.donot_show_categories?.value
                ? global.storeConfigration?.donot_show_categories?.value?.split(',')
                : [],
        },
    })

    useEffect(() => {
        if (search_allproducts.from === 'recentlyViewedItems') {
            setRecentlyViewedProducts(
                search_allproducts.results.length ? search_allproducts.results : [],
            )
        } else if (search_allproducts.from === 'suggestedItems') {
            setSuggestedProducts(
                search_allproducts.results.length ? search_allproducts.results : [],
            )
        } else {
            setViewProduct(search_allproducts.results.length ? search_allproducts.results : [])
        }
    }, [search_allproducts, formik.values])

    useEffect(() => {
        getAllSearchItems(
            {
                ...suggestedItemSearch,
            },
            'suggestedItems',
        )
    }, [suggestedItemSearch])

    useEffect(() => {
        if (global.storeConfigration?.enable_recently_viewed?.value == 1) {
            let items = JSON.parse(localStorage.getItem('recentlyViewed')) || []
            let whereCondition = `p.market_status="open" `
            if (items.length >= 1) {
                whereCondition += ` and p.id in (${items.join(',')})`
            }

            getAllSearchItems(
                {
                    ...recentlyViewedSearch,

                    customwhere: whereCondition,
                },
                'recentlyViewedItems',
            )
        }
    }, [recentlyViewedSearch])

    const NextArrow = ({ className, style, onClick, set5Next }) => {
        // const { className, style, onClick } = props
        return (
            <div
                className={`${className}`}
                style={{
                    ...style,
                    right: isMobile ? (set5Next ? '5px' : '35px') : -25,
                    top: isMobile ? (set5Next ? '125px' : '90px') : 70,
                    display: 'block',
                    zIndex: 999,
                }}
                onClick={onClick}
            >
                {/* <span className="material-icons-outlined" size="14">
                    navigate_next
                </span> */}
            </div>
        )
    }

    const PrevArrow = ({ className, style, onClick, set5Prev }) => {
        // const { className, style, onClick } = props
        return (
            <div
                className={`${className}`}
                style={{
                    ...style,
                    left: isMobile ? (set5Prev ? '-15px' : '15px') : -50,
                    top: isMobile ? (set5Prev ? '125px' : '90px') : 70,
                    display: 'block',
                    zIndex: 999,
                }}
                onClick={onClick}
            >
                {/* <span className="material-icons-outlined" size="14">
                    navigate_left
                </span> */}
            </div>
        )
    }

    const settings4 = {
        dots: false,
        fade: false,
        arrows: true,
        infinite: false,
        slidesToShow: 6,
        slidesToScroll: 1,
        autoplay: true,
        speed: 1000,
        nav: false,
        autoplaySpeed: 4000,
        cssEase: 'linear',
        nextArrow: <NextArrow />,
        prevArrow: <PrevArrow />,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 6,
                },
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 4,
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    centerPadding: 15,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                },
            },
        ],
    }

    const settings5 = {
        dots: false,
        fade: false,
        arrows: true,
        infinite: false,
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: true,
        speed: 1000,
        nav: false,
        centerMode: false,
        variableWidth: false,
        autoplaySpeed: 4000,
        // nextArrow: <NextArrow set5Next={'set5Next'} />,
        // prevArrow: <PrevArrow set5Prev={'set5Prev'} />,
        cssEase: 'linear',
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 4,
                },
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                },
            },
        ],
    }

    const handleQrClose = () => {
        setOpenQrModal(!openQrModal)
    }

    return (
        <>
            <SEOTAG page="Watchlist" />
            <Layout props={props}>
                {isVarifiedGfTheme ? (
                    <>
                        <div className="appendChildSuggestCard">
                            <div className="GFdashWrapperContainer">
                                <DashboardHeader />
                                <Container className="db-bids-wrapper gf-favour loa-favourites-wrapper">
                                    {/* <AppBar position="static" className="watchListHeaderContainer">
                                    <Tabs
                                        value={value}
                                        onChange={handleChange}
                                        aria-label="wrapped label tabs example"
                                    >
                                        <Tab
                                            value="one"
                                            label="Watching"
                                            wrapped
                                            {...a11yProps('one')}
                                        />
                                        <Tab value="two" label="Won" {...a11yProps('two')} />
                                        <Tab value="three" label="Lost" {...a11yProps('three')} />{' '}
                                    </Tabs>
                                </AppBar> */}
                                    <AppBar position="static" classsName="watchListHeaderContainer">
                                        <Tabs
                                            value={value}
                                            onChange={handleChange}
                                            aria-label="wrapped label tabs example"
                                        >
                                            <Tab
                                                value="one"
                                                label={
                                                    <span className="material-icons-outlined">
                                                        apps
                                                    </span>
                                                }
                                                cardType="GridCard"
                                                {...a11yProps('one')}
                                            ></Tab>
                                            <Tab
                                                value="two"
                                                label={
                                                    <span className="material-icons-outlined">
                                                        format_list_bulleted
                                                    </span>
                                                }
                                                cardType="listCard"
                                                {...a11yProps('two')}
                                            ></Tab>
                                        </Tabs>
                                    </AppBar>
                                    <TabPanel value={value} index="one">
                                        <FavouriteAuctions
                                            // page="auction"
                                            need_socket_update={1}
                                            cardTheme="LotsAuction"
                                            watchlist="isGFWatchList"
                                            cardType="GridCard"
                                        />
                                    </TabPanel>
                                    <TabPanel value={value} index="two">
                                        <FavouriteAuctions
                                            // page="auction"
                                            need_socket_update={1}
                                            cardTheme="LotsAuction"
                                            watchlist="isGFWatchList"
                                            cardType="listCard"
                                        />
                                    </TabPanel>
                                    <TabPanel value={value} index="three">
                                        <FavouriteAuctions
                                            // page="auction"
                                            need_socket_update={1}
                                            cardTheme="LotsAuction"
                                            watchlist="isGFWatchList"
                                        />
                                    </TabPanel>
                                </Container>
                            </div>
                            {!isBargainsProject && (
                                <div className="searchSuugerItemsBox mb-4">
                                    <h4 className="title">Suggested Items</h4>
                                    <div className="ssssss">
                                        {suggestedProducts.length >= 0 ? (
                                            <>
                                                <Slider {...settings5}>
                                                    {suggestedProducts.map((item, index) => (
                                                        <div
                                                            key={index}
                                                            className="px-2 gfGridCard"
                                                        >
                                                            <LotProduct
                                                                data={item}
                                                                lotImages={item.lotImages}
                                                                link={`/gallery/product-view/${item.id}`}
                                                                handleClick={() =>
                                                                    handleRedirectInternal(
                                                                        history,
                                                                        `product/${id}?cat=`,
                                                                    )
                                                                }
                                                                timerTheme={props.timerTheme}
                                                                type={props.type ? props.type : ''}
                                                                cardTheme={props.cardTheme}
                                                                card_theme="lotsauction"
                                                                noBuyNow={true}
                                                                noTimer={props.noTimer}
                                                                getAllProducts={
                                                                    getAllSearchProducts
                                                                }
                                                                setViewProduct={setViewProduct}
                                                                viewProduct={viewProduct}
                                                                audio={props.audio}
                                                                productViewLink={`/product/${item.id}?cat=`}
                                                                bidStatus="true"
                                                                timerIcon={true}
                                                                searchCard={true}
                                                                hideQuickBid={
                                                                    props.hideQuickBid
                                                                        ? props.hideQuickBid
                                                                        : false
                                                                }
                                                            />
                                                        </div>
                                                    ))}
                                                </Slider>
                                            </>
                                        ) : (
                                            <div className="card card-body text-center">
                                                No items Found!
                                            </div>
                                        )}
                                    </div>
                                </div>
                            )}
                        </div>
                        {!isBargainsProject && (
                            <div className="why-choose searchlayout">
                                <div className="customRecentContainer">
                                    <div className="googleReviewPoint mt-4 mb-4 recent">
                                        <h4 className="title">Recently Viewed</h4>
                                        {recentlyViewedProducts.length >= 0 ? (
                                            <Slider {...settings4}>
                                                {recentlyViewedProducts.map((data, index) => (
                                                    <Link to={`/product/${data.id}`}>
                                                        <div key={index} className="recenlyCard">
                                                            <img
                                                                src={`${process.env.REACT_APP_PRODUCT_IMAGE_URL}${data.avatar_vc}`}
                                                                alt="view Images"
                                                                width={100}
                                                                height={100}
                                                            />
                                                        </div>
                                                    </Link>
                                                ))}
                                            </Slider>
                                        ) : (
                                            <div className="card card-body text-center">
                                                No items Found!
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        )}
                        <Popup
                            open={openQrModal}
                            handleClose={handleQrClose}
                            modaltitle="Get QR Code"
                            handleGFModal={true}
                        >
                            <div className="schedulePickup">
                                <p>
                                    Show your QR code when you pick up your item. You must pick up
                                    your item(s) within 3 days.
                                </p>
                            </div>
                        </Popup>
                    </>
                ) : (
                    <>
                        <DashboardHeader />
                        <Container className="db-bids-wrapper mt-4 loa-favourites-wrapper">
                            <h2 className="mp-head">Favorites</h2>
                            {/* <Tabs
                        value={value}
                        onChange={handleChange}
                        aria-label="buyer-dashboard"
                        className="mt-4 liquidationDashTabs"
                    >

                        <Tab label="Auctions" {...a11yProps(0)} />
                        {global.storeConfigration?.disable_buynow?.value !== '1' ? (
                            <Tab label="Buy Now" {...a11yProps(1)} />
                        ) : null}
                    </Tabs>
                    <TabPanel value={value} index={0}>
                        
                    </TabPanel>
                    {global.storeConfigration?.disable_buynow?.value !== '1' ? (
                        <TabPanel value={value} index={1}>
                            <FavouriteAuctions page="buynow" cardTheme="LotsAuction" />
                        </TabPanel>
                    ) : null} */}
                            <FavouriteAuctions
                                page="auction"
                                need_socket_update={0}
                                cardTheme="LotsAuction"
                            />
                        </Container>
                    </>
                )}
            </Layout>
        </>
    )
}

export default Favourites
